import gql from 'graphql-tag';
import { IOffer } from '@belong/types/api/offers';

export interface ILoadOfferDetailsResponse {
  catalogOfferCollection: {
    items: IOffer[];
  };
}

// Try to find offer / promo details using parallel queries
export const loadOfferDetailsGql = gql`
  query loadOfferDetails($ids: [String]) {
    catalogOfferCollection(where: { id_in: $ids }) {
      items {
        id
        name
        groupingId
        channelAction
        eligibleChannels
        eligiblePlans
        productFamily
        startDate
        endDate
        rewards
      }
    }
  }
`;
